"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); } // +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var financialRouter = {
  path: '/financial',
  component: _layout.default,
  redirect: '/financial/commission/template',
  name: 'Financial',
  meta: {
    title: '财务',
    icon: 'clipboard'
  },
  children: [{
    path: 'commission',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/financial/index'));
      });
    },
    name: 'Commission',
    meta: {
      title: '财务操作',
      icon: ''
    },
    alwaysShow: true,
    children: [{
      path: 'template',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/financial/commission/withdrawal/index'));
        });
      },
      name: 'commissionTemplate',
      meta: {
        title: '申请提现',
        icon: ''
      }
    }]
  }, {
    path: 'record',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/financial/record/index'));
      });
    },
    name: 'financialRecord',
    meta: {
      title: '财务记录',
      icon: ''
    },
    alwaysShow: true,
    children: [{
      path: 'charge',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/financial/record/charge/index'));
        });
      },
      name: 'Charge',
      meta: {
        title: '充值记录',
        icon: ''
      }
    }, {
      path: 'monitor',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/financial/record/monitor/index'));
        });
      },
      name: 'Monitor',
      meta: {
        title: '资金监控',
        icon: ''
      }
    }]
  }, {
    path: 'brokerage',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/financial/brokerage/index'));
      });
    },
    name: 'Brokerage',
    meta: {
      title: '佣金记录',
      icon: ''
    }
  }]
};
var _default = exports.default = financialRouter;